'use strict';

var contactDefaultSubject = document.querySelector('[data-contact-subject-default]');

var setDefaultContactFormSubject = function setDefaultContactFormSubject() {
  var defaultSubjectId = contactDefaultSubject.dataset.contactSubjectDefault;
  var contactSubjectField = document.querySelector('#block-contactform select[name="subject"]');

  if (!defaultSubjectId || defaultSubjectId.length === 0 || !contactSubjectField) {
    return;
  }
  contactSubjectField.value = defaultSubjectId;
};

contactDefaultSubject && setDefaultContactFormSubject();


//////////////////
// WEBPACK FOOTER
// ./js/form/contact-subject.js
// module id = ./js/form/contact-subject.js
// module chunks = 0